export default "__VITE_ASSET__66ad6fcb__"